// extracted by mini-css-extract-plugin
module.exports = {"button":"ao","isRental":"ap","lightBGPrimary":"aq","secondary":"ar","iconButton":"as","darkBGSecondary":"at","warning":"au","outlined":"av"};